import { createFileRoute } from "@tanstack/react-router";
import { DashboardCard, CrudShellHeader, MERCHANT_HUB_GRID } from "@/components/ds";
import { ClinicalPageShell } from "@/components/clinical";
import { FeatureLockedState } from "@/components/workspace/FeatureLockedState";
import { PRODUCCION_HUB_LINKS } from "@/lib/workspace-hubs";
import { useTenantContext } from "@/lib/tenant-context";
import { b2bCopy } from "@/lib/merchant-feature-copy";
import { MerchantExperienceBar } from "@/components/renata/MerchantExperienceBar";

export const Route = createFileRoute("/app/produccion/")({
  component: ProduccionHubPage,
  head: () => ({ meta: [{ title: "B2B / Mayorista — Structura Market" }] }),
});

function ProduccionHubPage() {
  const { productFlags, businessProfile } = useTenantContext();
  const copy = b2bCopy(businessProfile);
  const locked = productFlags.produccion_b2b !== true;

  return (
    <div>
      <CrudShellHeader title={copy.hubTitle} description={copy.hubDescription} />
      <ClinicalPageShell offset="none" className="pt-6">
        {locked ? (
          <FeatureLockedState
            payload={{
              code: "plan_feature_locked",
              feature: "produccion_b2b",
              message: "B2B / Mayorista requiere plan Business o superior.",
            }}
          />
        ) : (
          <>
            <MerchantExperienceBar screenId="produccion-b2b" />
            <div className="mb-4">
              <p className="text-sm font-semibold text-foreground">¿Qué querés gestionar?</p>
            </div>
            <div className={MERCHANT_HUB_GRID} data-tour="workspace-hub">
              {PRODUCCION_HUB_LINKS.map((link) => (
                <DashboardCard
                  key={link.id}
                  to={link.href}
                  search={link.search}
                  icon={link.icon}
                  title={link.label}
                  subtitle={link.description ?? ""}
                />
              ))}
            </div>
          </>
        )}
      </ClinicalPageShell>
    </div>
  );
}
